import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";
import { SignUpUserBlobInterface } from "../../utility/interface/api/users/sign-up-user-res";
import { getAccessTokenSession } from "../../utility/common/session-store";

// signup
export const signupProvider = (signupBlob: SignUpUserBlobInterface) => {
  const url = `/providers`;
  const body = {
    ...signupBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// get provider hosts
export const getProviderHosts = () => {
  const url = `providers/hosts`;
  const token = getAccessTokenSession();
  return axiosClient.get<ResultDataModel<any>>(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const changeProviderPwd = (
  email: string,
  new_password: string,
  old_password: string,
) => {
  const url = `/changeProviderPwd`;
  const body = {
    email,
    new_password,
    old_password,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};
